import { BellFilled } from "@ant-design/icons";
import { Menu } from "antd";
import { apiGetNotices } from "helpers/api/notices";
import Cookies from "js-cookie";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE } from "routes/route";
import { getPatientInfo, getUserInfo, setPatientInfo } from "utils";
import "./styles.scss";

const ClinicMenu = (props) => {
  const { pathname } = useLocation();
  const [noticesData, setNoticesData] = useState([]);
  const userInfo = getUserInfo();
  const patientInfo = getPatientInfo();
  const { t } = useTranslation();

  const getNotices = () => {
    apiGetNotices().then((res) => {
      if (res.data) {
        setNoticesData(res.data);
      }
    });
  };

  useEffect(() => {
    getNotices();
    return () => {
      // setPatientInfo({});
    };
  }, []);

  const history = useHistory();
  const showInfo = ![
    ROUTE.CLINIC.CODE,
    ROUTE.CLINIC.SETTING,
    ROUTE.CLINIC.HELP_PAGE,
    ROUTE.CLINIC.NOTIFICATION,
    ROUTE.CLINIC.PATIENT,
    ROUTE.CLINIC.PATIENT_EDIT.replace(":id", patientInfo.id),
  ].includes(window.location.pathname);

  useEffect(() => {
    console.log("patientInfo", patientInfo);
    if (!showInfo) {
      setPatientInfo(patientInfo);
    }
  }, [showInfo, patientInfo]);

  const onClickMenu = ({ key, keyPath }) => {
    if (key === "/logout") {
      localStorage.clear();
      Cookies.remove("USER_INFO");
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      window.location.href = ROUTE.PUBLIC.LOGIN;
      return;
    }
    const reversed = keyPath.reverse();
    const path = reversed.join("");
    history.push(path);
    if (pathname !== key) {
      getNotices();
    }
    const { isInDrawer, onCloseDrawer } = props
    if (isInDrawer && onCloseDrawer) {
      onCloseDrawer();
    }
  };

  return (
    <div className="menu-content menu-clinic-container">
      <div className="home-left-logo">
        <img src="/icons/logo.webp" className="logo-icon" alt="icon-logo" onClick={() => {
          history.replace("/clinic/patient");
          const { isInDrawer, onCloseDrawer } = props
          if (isInDrawer && onCloseDrawer) {
            onCloseDrawer();
          }
        }} />
      </div>
      <div className="home-left-info">
        <div
          className="search-patient-button"
          onClick={() => {
            history.push(ROUTE.CLINIC.PATIENT);
            const { isInDrawer, onCloseDrawer } = props
            if (isInDrawer && onCloseDrawer) {
              onCloseDrawer();
            }
          }}
        >
          <div className="search-patient-button-text">
            {t("menu.clinic.listPatient")}
          </div>
          <div className="search-patient-button-text-plus">+</div>
        </div>
        {showInfo && (
          <div className="patient-info-container">
            <div className="patient-info ">
              <div className="patient-info-item">
                <div className="patient-info-item-label">
                  {t("menu.clinic.clinicName")}
                </div>
                <div className="patient-info-item-value">
                  <div className="patient-info-item-value-center">
                    {`${patientInfo?.first_name_clinic || patientInfo?.first_name || ""} ${patientInfo?.last_name_clinic || patientInfo?.last_name || ""
                      }`}
                  </div>
                  <div className="patient-info-item-value-right">
                    {patientInfo?.gender === "MALE"
                      ? t("gender.male")
                      : t("gender.female")}
                  </div>
                </div>
              </div>
              <div className="patient-info-item">
                <div className="patient-info-item-label">
                  {t("menu.clinic.idNo")}
                </div>
                <div className="patient-info-item-value">{patientInfo?.code}</div>
              </div>
              <div className="patient-info-item">
                <div className="patient-info-item-label">
                  {t("menu.clinic.birthday")}
                </div>
                <div className="patient-info-item-value">
                  <div className="patient-info-item-value-center">
                    {moment(patientInfo.date_of_birth).format("YYYY年M月D日")}
                  </div>
                  <div className="patient-info-item-value-right">
                    {t("menu.clinic.age", {
                      age: moment().diff(
                        patientInfo.date_of_birth,
                        "years",
                        false
                      ),
                    })}
                  </div>
                </div>
              </div>
              <div className="patient-info-item">
                <div className="patient-info-item-label">
                  {t("menu.clinic.startDateTreatment")}
                </div>
                <div className="patient-info-item-value">
                  {(patientInfo.treatment_start_date_clinic || patientInfo.treatment_start_date) && moment((patientInfo.treatment_start_date_clinic || patientInfo.treatment_start_date)).format(
                    "YYYY年M月D日"
                  )}
                </div>
                <div className="patient-info-item-value-sub">
                  {(patientInfo.treatment_start_date_clinic || patientInfo.treatment_start_date) && `(${t("menu.clinic.timeTreatment", {
                    month: moment().diff(
                      (patientInfo.treatment_start_date_clinic || patientInfo.treatment_start_date),
                      "month",
                      false
                    ),
                    day: moment().diff(
                      (patientInfo.treatment_start_date_clinic || patientInfo.treatment_start_date),
                      "days",
                      false
                    ) + 1,
                  })})`}
                </div>
              </div>
              <div className="patient-info-item">
                <div className="patient-info-item-label">
                  {t("menu.clinic.lastUpdateDate")}
                </div>
                <div className="patient-info-item-value">
                  {patientInfo.last_receive_date
                    ? moment(patientInfo.last_receive_date + "+00:00").format(
                      "YYYY年M月D日 HH:mm:ss"
                    )
                    : ""}
                </div>
              </div>
              <div className="patient-info-item-label">
                {t("menu.clinic.note")}
              </div>
              <div className="patient-info-item-input">
                <div className="patient-info-item-input-text">
                  {patientInfo?.memo}
                </div>
                <div className="patient-info-item-input-text-number">{`${patientInfo?.memo?.length || 0}/500`}</div>
              </div>
            </div>
          </div>
        )}

        <div className="home-left-menu">
          <Menu
            selectedKeys={[pathname]}
            mode="inline"
            theme="light"
            items={[
              {
                key: ROUTE.CLINIC.CODE,
                label: t("menu.clinic.clinicCode"),
                url: ROUTE.CLINIC.CODE,
                icon: (
                  <img
                    src="/icons/doctor.svg"
                    className="icon"
                    alt="doctor-icon-menu"
                  />
                ),
                childrens: [],
              },
              {
                key: ROUTE.CLINIC.SETTING,
                label: t("menu.clinic.setting"),
                url: ROUTE.CLINIC.SETTING,
                icon: (
                  <img
                    src="/icons/settings.svg"
                    className="icon"
                    alt="setting-icon-menu"
                  />
                ),
                childrens: [],
              },
              {
                key: ROUTE.CLINIC.HELP_PAGE,
                label: t("menu.clinic.help"),
                url: ROUTE.CLINIC.HELP_PAGE,
                icon: (
                  <img
                    src="/icons/help.svg"
                    className="icon"
                    alt="help-icon-menu"
                  />
                ),
                childrens: [],
              },
              {
                key: ROUTE.CLINIC.NOTIFICATION,
                label: t("menu.clinic.notice"),
                itemIcon: noticesData.some((item) => !item.read) ? (
                  <div
                    style={{
                      width: "10px",
                      height: "10px",
                      background: "#FF3131",
                      borderRadius: "50%",
                      position: "absolute",
                      left: "52%",
                      top: "10px",
                    }}
                  />
                ) : null,
                url: ROUTE.CLINIC.NOTIFICATION,
                icon: <BellFilled style={{ fontSize: "24px" }} />,
                childrens: [],
              },
              {
                key: ROUTE.PUBLIC.LOGOUT,
                label: t("menu.clinic.logout"),
                // url: ROUTE.PUBLIC.LOGOUT,
                childrens: [],
              },
            ]}
            onClick={onClickMenu}
          />
        </div>
      </div>
    </div>
  );
};

export default ClinicMenu;
